module.exports = __webpack_public_path__ + "static/img/wzry-companyProducts7.be5fa290.png";